import { useContext } from "react";
import { appContext } from "../../App";

const SvgDecorator = () => {
    const { darkMode } = useContext(appContext);

    return (
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden z-0">
            {/* Top Light Flare */}
            <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-500/5 dark:bg-blue-400/10 rounded-full blur-[120px] -translate-y-1/2"></div>

            {/* Middle Decorative Rings */}
            <div className="absolute top-[1200px] -right-32 w-[600px] h-[600px] opacity-10 dark:opacity-20 animate-[spin_60s_linear_infinite]">
                <img src="/assets/ic_bgring1.svg" className="w-full h-full" alt="" />
            </div>

            <div className="absolute top-[2800px] -left-32 w-[500px] h-[500px] opacity-5 dark:opacity-10 rotate-45">
                <img src="/assets/ic_bgring2.png" className="w-full h-full" alt="" />
            </div>

            {/* Bottom Accent */}
            <div className="absolute bottom-0 right-0 w-[800px] h-[800px] bg-blue-600/5 dark:bg-blue-500/10 rounded-full blur-[150px] translate-x-1/2 translate-y-1/2"></div>

            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default SvgDecorator;
